module.exports = __webpack_public_path__ + "static/media/md-cloudy.a7527ae4.svg";